var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InfosetsMemberActionsMenu',{attrs:{"member":_vm.member,"isAuthor":_vm.isAuthor,"infosetId":_vm.infosetId,"currentUser":_vm.currentUser},on:{"removeMember":_vm.removeMember}})}
var staticRenderFns = []

export { render, staticRenderFns }